import ClassNames from 'classnames';

type Props = {
	activeMicrophone: boolean;
	activeVideoCamera: boolean;
	toggleMicrophone: () => void;
	toggleVideoCamera: () => void;
};

export const MeetCameraBottom = ({ activeMicrophone, activeVideoCamera, toggleVideoCamera, toggleMicrophone }: Props) => {
	return (
		<>
			<div className="meet-bottom">
				<div className="button-group">
					<div
						className={ClassNames('btn-item', { active: activeMicrophone })}
						onClick={toggleMicrophone}>
						<i className="icons-microphone" />
					</div>
					<div
						className={ClassNames('btn-item', { active: activeVideoCamera })}
						onClick={toggleVideoCamera}>
						<i className="icons-videocamera" />
					</div>
				</div>
			</div>
		</>
	);
};
